import React from 'react'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import { Link } from 'react-router-dom'
import { MdOutlineArrowForward } from 'react-icons/md'

export default function PrivacyPolicy() {
  return (
    <>
      <Navbar />
      <section className="relative table w-full py-36 bg-[url('../../assets/images/bg/bg1.svg')] bg-bottom bg-no-repeat">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900"></div>
        <div className="container">
          <div className="grid grid-cols-1 pb-8 text-center mt-10">
            <h3 className="md:text-3xl text-2xl md:leading-snug tracking-wide leading-snug font-medium text-white">
              Privacy Policy
            </h3>
            <p className="text-slate-400">Last Updated: FEBRUARY 13, 2025</p>
          </div>
        </div>
        <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
          <ul className="breadcrumb tracking-[0.5px] breadcrumb-light mb-0 inline-block">
            <li className="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white/50 hover:text-white">
              <Link to="/">NINFTY</Link>
            </li>
            <li className="inline breadcrumb-item text-[15px] font-semibold duration-500 ease-in-out text-white" aria-current="page">
              Privacy Policy
            </li>
          </ul>
        </div>
      </section>
      <div className="relative">
        <div className="shape absolute start-0 end-0 sm:-bottom-px -bottom-[2px] overflow-hidden z-1 text-white dark:text-slate-900">
          <svg className="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
          </svg>
        </div>
      </div>
      <section className="relative md:py-24 py-16">
        <div className="container">
          <div className="md:flex justify-center">
            <div className="md:w-3/4">
              <div className="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-md">
                {/* What Information We Collect */}
                <h5 className="text-xl font-semibold mb-4">What Information We Collect</h5>
                <p className="text-slate-400">We may collect the following types of information:</p>
                <ul className="list-none text-slate-400 mt-4">
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>
                      <strong>Personal Information:</strong> email address, wallet details, purchase history.
                      <br />
                      Name, Surname we collect could be different from your real data; we don’t check or restrict that due to the fact that we do not collect that personal data.
                    </span>
                  </li>
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>
                      <strong>Non-Personal Information:</strong> Browser type, device information, IP address, and usage data collected through cookies and analytics tools.
                    </span>
                  </li>
                </ul>
                <p className="text-slate-400 mt-4">
                  You confirm that you will not provide us with personal information if you are not eligible to give consent for such data provision.
                </p>
                <p className="text-slate-400">
                  You agree that you will not provide us with personal information of anyone other than yourself unless you first obtain the consent of the person on whose behalf you are providing the information, or you are that person's justified representative.
                </p>

                {/* How We Use Your Information */}
                <h5 className="text-xl font-semibold mb-4 mt-8">How We Use Your Information</h5>
                <p className="text-slate-400">Our information collection goals: We use your information to:</p>
                <ul className="list-none text-slate-400 mt-4">
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>
                      <strong>email address</strong> – for provision of our services (authentication on personal account, restore access, communication)
                    </span>
                  </li>
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>
                      <strong>wallet details</strong> – for provision of our services (further assassination of purchases)
                    </span>
                  </li>
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>
                      <strong>purchase history</strong> – for provision of our services (retrospective data allowance is an integral part of our services)
                    </span>
                  </li>
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>
                      <strong>Browser and Device Information</strong> – for our website functionality and fraud prevention
                    </span>
                  </li>
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>
                      <strong>Name, Surname</strong> – for convenience only (not mandatory matching your real data)
                    </span>
                  </li>
                </ul>

                {/* How We Share Your Information */}
                <h5 className="text-xl font-semibold mb-4 mt-8">How We Share Your Information</h5>
                <p className="text-slate-400">We do not sell or rent your personal information. However, we may share your data with:</p>
                <ul className="list-none text-slate-400 mt-4">
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>Service providers (e.g., payment processors, hosting services) for operational purposes</span>
                  </li>
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>Legal authorities if required by law or to protect our rights</span>
                  </li>
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>Business partners if you have given your consent</span>
                  </li>
                </ul>

                {/* Cookies and Tracking Technologies */}
                <h5 className="text-xl font-semibold mb-4 mt-8">Cookies and Tracking Technologies</h5>
                <p className="text-slate-400">
                  We use cookies and similar technologies to enhance user experience, analyze trends, and track website activity. You can manage your cookie preferences by clicking the "Cookie Preferences" button in the bottom right corner of the screen.
                </p>

                {/* Data Security */}
                <h5 className="text-xl font-semibold mb-4 mt-8">Data Security</h5>
                <p className="text-slate-400">
                  We implement industry-standard security measures to protect your data from unauthorized access, disclosure, or loss.
                </p>
                <h6 className="text-lg font-semibold mb-4 mt-4">How do we store your data?</h6>
                <p className="text-slate-400">
                  Our company uses administrative, technical, and physical safeguards to protect the security, confidentiality, and integrity of your personal information against loss, misuse, and unauthorized access, disclosure, alteration, and destruction. We also use encryption protocols and software to transmit sensitive data.
                </p>
                <p className="text-slate-400">
                  You can assist us by keeping your password and login information confidential, terminating sessions, closing the browser, and logging out when accessing our services from shared devices.
                </p>

                {/* Your Rights */}
                <h5 className="text-xl font-semibold mb-4 mt-8">Your Rights</h5>
                <p className="text-slate-400">
                  Depending on your location, you may have rights regarding your personal data, including access, correction, deletion, and opting out of marketing communications. Contact us to exercise these rights.
                </p>
                <p className="text-slate-400">
                  If you are located in the European Economic Area (EEA), the United Kingdom (UK), or are otherwise subject to the General Data Protection Regulation (GDPR), you have additional rights, including:
                </p>
                <ul className="list-none text-slate-400 mt-4">
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>The right to request access to your personal data</span>
                  </li>
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>The right to rectify inaccurate or incomplete data</span>
                  </li>
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>The right to request deletion of your personal data (subject to legal limitations)</span>
                  </li>
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>The right to restrict processing under certain conditions</span>
                  </li>
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>The right to data portability</span>
                  </li>
                  <li className="flex items-start mt-2">
                    <MdOutlineArrowForward className="text-violet-600 text-base align-middle me-2" />
                    <span>The right to object to processing based on legitimate interests or direct marketing</span>
                  </li>
                </ul>
                <p className="text-slate-400 mt-4">
                  If you wish to exercise any of these rights under GDPR, please contact us at{" "}
                  <a href="mailto:info@ninfty-art.com" className="underline text-violet-600 hover:text-violet-500">
                    info@ninfty-art.com
                  </a>{" "}
                  or via the <Link to="/contact" className="underline text-violet-600 hover:text-violet-500">Contact Us</Link> page.
                </p>
                <p className="text-slate-400">
                  We will make reasonable efforts to incorporate changes to your personal data upon request. We may ask you to verify your identity before making any changes.
                </p>
                <p className="text-slate-400">
                  We may retain a copy of your prior information for our records and will respond to all requests for access within 30 days.
                </p>
                <p className="text-slate-400">
                  We will retain your information (including geo-location data) for as long as your account is active, and as necessary to provide services, comply with legal obligations, resolve disputes, and enforce our agreements.
                </p>

                {/* Third-Party Links */}
                <h5 className="text-xl font-semibold mb-4 mt-8">Third-Party Links</h5>
                <p className="text-slate-400">
                  Our website may contain links to third-party websites. We are not responsible for their privacy practices and recommend reviewing their policies before providing any information.
                </p>

                {/* Children’s Privacy */}
                <h5 className="text-xl font-semibold mb-4 mt-8">Children’s Privacy</h5>
                <p className="text-slate-400">
                  If you are under 18, you may use our products and services only with the involvement of a parent or guardian. Our website and marketing are not directed to children under 13 years of age.
                </p>

                {/* Changes to This Policy */}
                <h5 className="text-xl font-semibold mb-4 mt-8">Changes to This Policy</h5>
                <p className="text-slate-400">
                  We may update this Privacy Policy from time to time. The latest version will be available on our website with the "Last Updated" date.
                </p>

                {/* Contact Us */}
                <h5 className="text-xl font-semibold mb-4 mt-8">Contact Us</h5>
                <p className="text-slate-400">
                  If you have any questions about this Privacy Policy, please contact us at{" "}
                  <a href="mailto:info@ninfty-art.com" className="underline text-violet-600 hover:text-violet-500">
                    info@ninfty-art.com
                  </a>{" "}
                  or via the <Link to="/contact" className="underline text-violet-600 hover:text-violet-500">Contact Us</Link> page.
                </p>

                {/* How to Contact the Appropriate Authority */}
                <h5 className="text-xl font-semibold mb-4 mt-8">How to Contact the Appropriate Authority</h5>
                <p className="text-slate-400">
                  Should you wish to report a complaint or if you feel that we have not addressed your concern in a satisfactory manner, you may contact the Information Commissioner’s Office (ICO) or another local authority.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}
